var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBooking
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("booking-form", {
              ref: "form",
              attrs: {
                "property-mutator": _vm.setBookingProperty,
                booking: _vm.booking,
                "validation-triggered": _vm.validationTriggered,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dashboard-block" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { click: _vm.handleSaveBookingCallback },
                  },
                  [_vm._v("\n        Save Booking\n      ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Edit Booking")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }